import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { TrackingUtils } from '../../../utils';

const CarouselBullet = ({ value, selected, setSelected, trackEvent }) => {
    const onClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        // trackEvent
        trackEvent({
            action: TrackingUtils.ACTION.CAROUSEL,
            label: TrackingUtils.LABEL.offerNext(value),
        });
        setSelected(value);
    };

    return (
        <a
            key={value}
            href="#"
            className={classNames('odf-bullet-scroll-negative', {
                selected: value === selected,
            })}
            onClick={onClick}
        />
    );
};

CarouselBullet.propTypes = {
    value: PropTypes.number.isRequired,
    selected: PropTypes.number.isRequired,
    setSelected: PropTypes.func.isRequired,
    trackEvent: PropTypes.func.isRequired,
};

export { CarouselBullet };
